module.exports = "/_next/static/images/kit-phone-diputi@2x-min-cb75a527ba702f639c668e62c5b06f94.png";